import mixpanel from "mixpanel-browser";
import { useCurrentAuth } from "core/features/auth/auth.store";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { clarity } from "react-microsoft-clarity";

export function trackEvent(eventName: string, props?: any) {
  if (!props) {
    props = {};
  }

  const { tenant } = useCurrentTenant.getState();
  const { auth } = useCurrentAuth.getState();

  props.createdAt = new Date().toISOString();
  props.userId = auth?.id ?? null;
  props.userName = auth?.nome ?? null;
  props.tenantId = tenant?.id ?? null;
  props.tenantName = tenant?.nome ?? null;

  mixpanel.track(eventName, props);
  clarity.setEvent(eventName);
}
